import React, { Fragment, useCallback, useEffect, useRef, useState, useContext, useMemo } from "react";
import {
  Form,
  FormGroup,
  Label,
  Input,
  Button,
  Card,
  CardBody,
  Row,
  Col,
  CardFooter,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import FalconCardHeader from "../common/FalconCardHeader";
import WizardError from "../auth/register/WizardError";
import FileUploadArea from "../common/FileUploadArea";
import classNames from "classnames";
import ButtonIcon from "../common/ButtonIcon";
import { Controller, useForm, useWatch } from "react-hook-form";
import NumberFormat from "react-number-format";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBan, faPiggyBank, faPlus, faUndo } from "@fortawesome/free-solid-svg-icons";
import withRedirect from "../../helpers/hoc/withRedirect";
import { useParams } from "react-router";
import { PreloadState } from "../UI/preloading/PreloadState";
import {
  fetchCreateToPayProvider,
  fetchCurrentAccount,
  fetchReserve,
} from "../../helpers/api/finance";
import { useSelector } from "react-redux";

import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import { Toast } from "../UI/toast/Toast";
import handleErrorMessage from "../../helpers/errors/handleErrorMessage";
import { CurrencyContext } from "../../context/Context";
import moment from "moment";
import useExchangeRateForDate from "../../helpers/hooks/useExchangeRateForDate";
import {
  convertFromUsd,
  convertToUsd,
  formatAmountForBackend,
  formatAmountRounded,
  getCurrencyName,
  truncateAmount,
} from "../../helpers/currencyConversion";
import Datetime from "react-datetime";
import { findAllCurrencies } from "../../helpers/api/currency";
import useModuleBase from "../../helpers/hooks/useModuleBase";
import { fetchAllPages } from "../../helpers/api/pagination";

const CreateDebtToPayForm = ({
  debttopay,
  handleSubmitData,
  handler,
  providers,
  setRedirect,
  setRedirectUrl,
  isAdd,
  debttopayId,
  setIsAdd,
}) => {
  const moduleBase = useModuleBase();

  const { id } = useParams();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { currency: curr, baseCurrency } = useContext(CurrencyContext);
  const activeExchangeRate = Number(curr?.value ?? 0);

  const {
    register,
    handleSubmit,

    control,
    formState: { isSubmitting, errors },
    setValue,
    clearErrors,
  } = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
    shouldFocusError: true,
    shouldUnregister: false,
    defaultValues: {
      payment_date: moment().format("YYYY-MM-DD"),
      monedaOriginal: curr?.currency?.id ? String(curr.currency.id) : "",
    },
  });

  const watchedPaymentDate = useWatch({
    control,
    name: "payment_date",
    defaultValue: moment().format("YYYY-MM-DD"),
  });

  const watchedCurrency = useWatch({
    control,
    name: "monedaOriginal",
    defaultValue: "",
  });

  /* const { nextPage, previousPage, perPage, goToPage, meta } = handler; */

  const [imagePreview, setImagePreview] = useState(null);

  const [file, setFile] = useState(null);
  /*   const [selectedProvider, setSelectedProvider] = useState(null); */
  const [collapseOne, collapseOneOpen] = useState(false);

  register("amount");
  register("voucher");
  register("bank_id");
  setValue("debts_to_pay_id", debttopayId);

  const basePendingAmount = Number(debttopay.amount - debttopay.total_paid);
  const [fund, setFund] = useState(false);
  const [amount, setAmount] = useState(basePendingAmount);
  const hasManualAmountOverrideRef = useRef(false);
  const lastAutoAmountRef = useRef(basePendingAmount);
  const [selectedFundSource, setSelectedFundSource] = useState("Selecciona");
  const [usesReserveFund, setUsesReserveFund] = useState(false);
  const [shouldSyncAmountWithSource, setShouldSyncAmountWithSource] = useState(false);
  const [account, setAccount] = useState([]);
  const fetchApiAccount = useCallback(async () => {
    try {
      const response = await fetchCurrentAccount(selectedCondominium);
      setAccount(
        response.data && response.data.length >= 0 ? response.data : []
      );
      console.log(response);
    } catch (error) {
      setAccount([]);
    }
  }, []);
  useEffect(() => {
    fetchApiAccount();
  }, [fetchApiAccount]);

  // Monedas en las que se puede emitir el pago. Igual que el pago del
  // propietario: la eleccion es libre y no depende del origen de fondos, asi
  // se puede pagar en bolivares aunque el dinero salga de Caja.
  const [availableCurrencies, setAvailableCurrencies] = useState([]);
  useEffect(() => {
    let isMounted = true;
    const loadCurrencies = async () => {
      try {
        const response = await fetchAllPages((page, pageSize) => findAllCurrencies(page, pageSize, {
          condominium_id: selectedCondominium,
        }));
        if (isMounted) setAvailableCurrencies(response?.data || []);
      } catch (error) {
        if (isMounted) setAvailableCurrencies([]);
      }
    };
    loadCurrencies();
    return () => {
      isMounted = false;
    };
  }, [selectedCondominium]);

  const currencyCatalog = useMemo(() => {
    const normalized = (availableCurrencies || []).map((item) => ({
      ...item,
      id: String(item.id),
      iso: (item?.iso || "").toUpperCase(),
      isFallbackUsd: false,
    }));

    // La moneda base no vive en la tabla de monedas del condominio, pero
    // siempre tiene que poder elegirse.
    if (!normalized.some((item) => item.iso === baseCurrency.iso)) {
      normalized.push({
        id: baseCurrency.iso,
        iso: baseCurrency.iso,
        name: getCurrencyName(baseCurrency.iso),
        isFallbackUsd: true,
      });
    }

    return normalized;
  }, [availableCurrencies, baseCurrency.iso]);

  const selectedCurrencyData = useMemo(
    () =>
      currencyCatalog.find((item) => String(item.id) === String(watchedCurrency)) ||
      null,
    [currencyCatalog, watchedCurrency]
  );

  const isSelectedCurrencyBase =
    (selectedCurrencyData?.iso || "").toUpperCase() === baseCurrency.iso;

  // Sin moneda elegida todavia se preselecciona la del condominio, y si no la
  // base, para que el formulario nunca arranque sin prefijo ni tasa.
  useEffect(() => {
    if (watchedCurrency || currencyCatalog.length === 0) {
      return;
    }
    const preferred =
      currencyCatalog.find(
        (item) => String(item.id) === String(curr?.currency?.id)
      ) || currencyCatalog[0];
    if (preferred) {
      setValue("monedaOriginal", String(preferred.id), { shouldDirty: false });
    }
  }, [currencyCatalog, curr, setValue, watchedCurrency]);

  const [reserve, setReserve] = useState([]);
  const fetchApiReserve = useCallback(async () => {
    try {
      const response = await fetchReserve(selectedCondominium);
      setReserve(
        response.data && response.data.length >= 0 ? response.data : []
      );
      console.log(response);
    } catch (error) {
      setAccount([]);
    }
  }, []);
  useEffect(() => {
    fetchApiReserve();
  }, [fetchApiReserve]);

  const renderFundsItems2 = () => {
    const cuenta = {
      CURRENT: "Caja",
      BANK: "Banco",
    };
    return account.filter((fund) => fund.type !== "ADVANCES").map((fund) => (
      <option
        value={
          fund.type === "BANK" ? `BANK_${fund.condominium_bank_id}` : fund.type
        }
        key={fund.id}
      >
        {cuenta[fund.type]} {fund.bank_name ? `- ${fund.bank_name}` : ""}
      </option>
    ));
  };

  console.log(reserve);

  const paymentDateMoment = useMemo(
    () => (watchedPaymentDate ? moment(watchedPaymentDate) : null),
    [watchedPaymentDate]
  );

  // La tasa sale de la FECHA DEL PAGO, no del dia en que se carga: un pago
  // registrado hoy pudo salir del banco la semana pasada, y es la tasa de ese
  // dia la que cuadra contra el banco.
  const { appliedExchangeRate, isRateLoading, rateResolution } = useExchangeRateForDate({
    currencyId: selectedCurrencyData?.id,
    isUsdCurrency: isSelectedCurrencyBase || Boolean(selectedCurrencyData?.isFallbackUsd),
    date: paymentDateMoment,
    activeExchangeRate,
    condominiumId: selectedCondominium,
  });

  // Tasa de la moneda local del condominio para esa misma fecha. Hace falta
  // cuando se paga en la moneda base: el monto convertido que descuenta el
  // saldo en bolivares del banco no se puede sacar de la tasa de arriba, que
  // en ese caso vale 1.
  //
  // Si la moneda elegida YA es la local se pasa currencyId null para no pedir
  // dos veces la misma tasa: el hook registra en trasfondo la tasa que
  // consulta, y dos llamadas iguales dejarian la fecha duplicada.
  const localCurrencyId = curr?.currency?.id;
  const isSelectedCurrencyLocal =
    Boolean(localCurrencyId) &&
    String(selectedCurrencyData?.id) === String(localCurrencyId);

  const { appliedExchangeRate: localCurrencyRate } = useExchangeRateForDate({
    currencyId: isSelectedCurrencyLocal ? null : localCurrencyId,
    isUsdCurrency: false,
    date: paymentDateMoment,
    activeExchangeRate,
    condominiumId: selectedCondominium,
  });

  const normalizedDayRate = useMemo(() => {
    const truncatedRate = truncateAmount(appliedExchangeRate, 6);
    return truncatedRate === "" ? 0 : Number(truncatedRate);
  }, [appliedExchangeRate]);

  // Tasa bolivares/moneda base de la fecha del pago, venga de donde venga la
  // moneda elegida. Es la que se guarda en el pago y la que convierte el monto.
  const rateForPaymentDate = useMemo(() => {
    const resolved = isSelectedCurrencyLocal ? normalizedDayRate : localCurrencyRate;
    const truncated = truncateAmount(resolved, 6);
    return truncated === "" ? 0 : Number(truncated);
  }, [isSelectedCurrencyLocal, localCurrencyRate, normalizedDayRate]);

  const amountPrefix = selectedCurrencyData?.iso
    ? `${selectedCurrencyData.iso} `
    : `${baseCurrency.symbol} `;

  // El tope es siempre lo que falta por pagar, expresado en la moneda elegida.
  const maxAllowedAmount = useMemo(() => {
    if (isSelectedCurrencyBase || !normalizedDayRate || Number(normalizedDayRate) <= 0) {
      return basePendingAmount;
    }

    const convertedLimit = convertFromUsd(basePendingAmount, false, normalizedDayRate);
    return convertedLimit === "" ? basePendingAmount : Number(convertedLimit);
  }, [basePendingAmount, isSelectedCurrencyBase, normalizedDayRate]);

  const approximateBaseAmount = useMemo(() => {
    if (isSelectedCurrencyBase) {
      return null;
    }

    const convertedAmount = convertToUsd(amount, false, normalizedDayRate);
    return convertedAmount === "" ? null : convertedAmount;
  }, [amount, isSelectedCurrencyBase, normalizedDayRate]);

  const conversionHelpText = useMemo(() => {
    if (isSelectedCurrencyBase || isRateLoading) {
      return "";
    }

    if (approximateBaseAmount === null) {
      return "";
    }

    const effectiveRateDate = rateResolution?.usedDateKey
      ? moment(rateResolution.usedDateKey)
      : paymentDateMoment;
    const dateLabel = effectiveRateDate ? effectiveRateDate.format("DD/MM/YYYY") : "";
    const rateLabel = appliedExchangeRate
      ? formatAmountRounded(normalizedDayRate, 2)
      : "N/D";

    return `Tasa ${dateLabel}: ${rateLabel} · Equivale a ${baseCurrency.symbol}${formatAmountRounded(
      approximateBaseAmount,
      2
    )}`;
  }, [
    approximateBaseAmount,
    baseCurrency.iso,
    baseCurrency.symbol,
    isRateLoading,
    isSelectedCurrencyBase,
    normalizedDayRate,
    paymentDateMoment,
    rateResolution,
  ]);

  const renderReserveItems = () => {
    return reserve.length > 0
      ? reserve.map((fund) => (
        <option value={fund.id} key={fund.id}>
          {fund.name} - {fund.money_available}$
        </option>
      ))
      : (
        <option disabled value="">
          No hay fondos de reserva registrados
        </option>
      );
  };
  /*   const handleImageUpload = async (event) => {

  };
 */


  console.log(errors);

  useEffect(() => {
    if (!shouldSyncAmountWithSource) {
      return;
    }

    if (isSelectedCurrencyBase) {
      const normalizedBaseAmount = Number(truncateAmount(basePendingAmount, 6) || 0);
      lastAutoAmountRef.current = normalizedBaseAmount;
      hasManualAmountOverrideRef.current = false;
      setAmount(normalizedBaseAmount);
      setValue("amount", normalizedBaseAmount);
      setShouldSyncAmountWithSource(false);
      return;
    }

    // Wait until the hook resolves which rate/date applies for today.
    // This avoids converting with a temporary fallback rate and then showing a different final rate in the helper text.
    if (!rateResolution?.selectedDateKey) {
      return;
    }

    if (
      paymentDateMoment &&
      paymentDateMoment.isValid() &&
      rateResolution.selectedDateKey !== paymentDateMoment.format("YYYY-MM-DD")
    ) {
      return;
    }

    if (isRateLoading || !normalizedDayRate || Number(normalizedDayRate) <= 0) {
      return;
    }

    const convertedAmount = convertFromUsd(basePendingAmount, false, normalizedDayRate);
    if (convertedAmount !== "") {
      const numericConvertedAmount = Number(truncateAmount(convertedAmount, 6) || 0);
      lastAutoAmountRef.current = numericConvertedAmount;
      hasManualAmountOverrideRef.current = false;
      setAmount(numericConvertedAmount);
      setValue("amount", numericConvertedAmount);
    }
    setShouldSyncAmountWithSource(false);
  }, [
    basePendingAmount,
    isRateLoading,
    isSelectedCurrencyBase,
    normalizedDayRate,
    paymentDateMoment,
    rateResolution,
    setValue,
    shouldSyncAmountWithSource,
  ]);

  const paymentDateKey =
    paymentDateMoment && paymentDateMoment.isValid()
      ? paymentDateMoment.format("YYYY-MM-DD")
      : null;

  useEffect(() => {
    if (!paymentDateKey || hasManualAmountOverrideRef.current) {
      return;
    }
    setShouldSyncAmountWithSource(true);
  }, [paymentDateKey]);

  // Al cambiar de moneda se vuelve a expresar lo que falta por pagar en la
  // moneda nueva, para no dejar en pantalla una cifra en la moneda anterior.
  useEffect(() => {
    if (!watchedCurrency) {
      return;
    }
    hasManualAmountOverrideRef.current = false;
    setShouldSyncAmountWithSource(true);
  }, [watchedCurrency]);

  const createS = async (values) => {
    const {
      debts_to_pay_id,
      description,
      reference,
      /* amount, */
      payment_date,
      reserve_fund_id,
    } = values;

    try {
      if (!selectedFundSource || selectedFundSource === "Selecciona") {
        Toast.fire({
          type: "error",
          title: "Seleccione el origen de fondos.",
        });
        return;
      }

      if (!payment_date) {
        Toast.fire({
          type: "error",
          title: "La fecha del pago es obligatoria.",
        });
        return;
      }

      // Pagar en una moneda distinta de la base exige la tasa real de esa
      // fecha: con una de referencia, el monto que queda guardado no es el que
      // salio del banco ese dia y el pago deja de conciliar.
      if (!isSelectedCurrencyBase) {
        if (!normalizedDayRate || Number(normalizedDayRate) <= 0 || rateResolution?.isFallback) {
          Toast.fire({
            type: "error",
            title: "No hay una tasa registrada para la fecha del pago en la moneda elegida.",
          });
          return;
        }
      }

      const normalizedBaseAmount = convertToUsd(
        amount,
        isSelectedCurrencyBase,
        normalizedDayRate
      );

      if (normalizedBaseAmount === "" || Number(normalizedBaseAmount) <= 0) {
        Toast.fire({
          type: "error",
          title: "Ingrese un monto valido mayor a 0.",
        });
        return;
      }

      // Monto en la moneda local: es el que descuenta el saldo en bolivares
      // del banco. Si se pago en esa moneda es el monto tal cual; si se pago en
      // la moneda base se convierte con la tasa local de la fecha del pago.
      let normalizedBsAmount = "";

      if (!isSelectedCurrencyBase) {
        normalizedBsAmount = String(amount);
      } else {
        if (!rateForPaymentDate || Number(rateForPaymentDate) <= 0) {
          Toast.fire({
            type: "error",
            title: "No hay una tasa registrada para la fecha del pago para calcular el monto en moneda local.",
          });
          return;
        }

        normalizedBsAmount = convertFromUsd(normalizedBaseAmount, false, rateForPaymentDate);

        if (normalizedBsAmount === "" || Number(normalizedBsAmount) <= 0) {
          Toast.fire({
            type: "error",
            title: "No se pudo calcular el monto convertido en moneda local.",
          });
          return;
        }
      }

      if (usesReserveFund) {
        if (!reserve_fund_id || reserve_fund_id === "Selecciona") {
          Toast.fire({
            type: "error",
            title: "Debe seleccionar un fondo de reserva.",
          });
          return;
        }
      }

      const formData = new FormData();
      const resolvedPayFromAccountCurrent =
        selectedFundSource === "CURRENT" || selectedFundSource.startsWith("BANK_")
          ? 1
          : 0;

      /*   formData.append("account_number", account_number);
        formData.append("bank_name", bank_name); */
      formData.append("debts_to_pay_id", debts_to_pay_id);
      formData.append("description", description);
      /*       formData.append("owner_dni", owner_dni); */
      /*  formData.append("owner_name", owner_name); */
      formData.append("reference", reference);
      formData.append("amount", formatAmountForBackend(normalizedBaseAmount));
      formData.append("amount_bs", formatAmountForBackend(normalizedBsAmount));
      formData.append("payment_date", payment_date);
      formData.append("pay_from_account_current", resolvedPayFromAccountCurrent);
      // La tasa que se guarda con el pago es la de su fecha, no la de hoy.
      if (rateForPaymentDate) formData.append("rate", rateForPaymentDate);

      const selectedBankId = selectedFundSource.startsWith("BANK_")
        ? selectedFundSource.split("_")[1]
        : null;

      if (selectedBankId) {
        formData.append("bank_id", selectedBankId);
      }
      if (usesReserveFund) {
        formData.append("reserve_fund_id", reserve_fund_id);
      }

      if (file) formData.append("voucher", file);

      const { code } = await fetchCreateToPayProvider(
        selectedCondominium,
        formData
      );

      if (code === SUCCESS_RESPONSE.OK) {
        setRedirectUrl(`/dashboard/${moduleBase}/${id}/topay`);
        setRedirect(true);
        Toast.fire({
          type: "success",
          title: `Pago registrado exitosamente.`,
        });
      }
    } catch (error) {
      handleErrorMessage(error);
      console.log(error);
    }
  };

  const renderForm = () => {
    return (
      <>
        <FalconCardHeader title="Detalle de pago" light={false} />
        <CardBody>
          {/* De donde sale el monto que aparece abajo: sin esto la cifra
              precargada no se explica, sobre todo cuando ya hubo un abono. */}
          <Row form>
            <Col tag={FormGroup}>
              <div className="bg-white border rounded px-3 py-2 fs--1">
                <span className="text-700 mr-1">Monto total:</span>
                <span className="font-weight-semi-bold mr-3">
                  <NumberFormat
                    displayType="text"
                    prefix={`${baseCurrency.symbol} `}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale
                    value={debttopay.amount}
                  />
                </span>
                {Number(debttopay.total_paid) > 0 && (
                  <>
                    <span className="text-700 mr-1">Abonado:</span>
                    <span className="font-weight-semi-bold mr-3">
                      <NumberFormat
                        displayType="text"
                        prefix={`${baseCurrency.symbol} `}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale
                        value={debttopay.total_paid}
                      />
                    </span>
                  </>
                )}
                <span className="text-700 mr-1">Pendiente:</span>
                <span className="font-weight-semi-bold text-primary">
                  <NumberFormat
                    displayType="text"
                    prefix={`${baseCurrency.symbol} `}
                    thousandSeparator={true}
                    decimalScale={2}
                    fixedDecimalScale
                    value={basePendingAmount}
                  />
                </span>
              </div>
            </Col>
          </Row>
          {/*   <FormGroup>
            <Label for="bank_name">Nombre del banco</Label>
            <Input
              onChange={(event) => {
                register("bank_name");
                setValue("bank_name", event.target.value);
              }}
              innerRef={register({
                minLength: {
                  value: 4,
                  message:
                    "El nombre del periodo debe tener al menos 4 caracteres.",
                },
                pattern: {
                  value: /^[a-zA-Z0-9 %]+$/i,
                  message: "Solo se aceptan alfanúmericos.",
                },
              })}
              autoComplete="off"
              name="bank_name"
              id="title"
              placeholder="Nombre del banco"
            />
          </FormGroup> */}

          {/*       <Row form>
            <Col sm tag={FormGroup}>
              <Label for="account_number">Número de cuenta</Label>
              <NumberFormat
              
                placeholder="Número de cuenta"
                className="form-control"


                onChange={(event) => {
                  register("account_number");
                  setValue("account_number", event.target.value);
                }}
              />
            </Col>
            <Col sm tag={FormGroup}>
              <Label for="owner_name">Titular</Label>
              <Input
              
                autoComplete="off"
                name="owner_name"
                id="owner_name"
                placeholder="Nombre del propietario"
                onChange={(event) => {
                  register("owner_name");
                  setValue("owner_name", event.target.value);
                }}
                innerRef={register({
                  minLength: {
                    value: 4,
                    message:
                      "El nombre del periodo debe tener al menos 4 caracteres.",
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9 %]+$/i,
                    message: "Solo se aceptan alfanúmericos.",
                  },
                })}
              />
            </Col>
          </Row> */}
          {/*      <Row form>
            <Col sm tag={FormGroup}>
              <Label for="owner_dni">Identificación (DNI)</Label>
              <Input
                id="owner_dni"
                name="owner_dni"
                type="text"
                placeholder="Identificación"
                onChange={(event) => {
                  register("owner_dni");
                  setValue("owner_dni", event.target.value);
                }}
                innerRef={register({
                  minLength: {
                    value: 7,
                    message: "La identificacion debe tener al menos 7 numeros.",
                  },
                  pattern: {
                    value: /^[a-zA-Z0-9 %]+$/i,
                    message: "Solo se aceptan alfanúmericos.",
                  },
                })}
              />
            </Col>
          </Row> */}
          <Row>
            <Col tag={FormGroup}>
              <Label>Código de referencia</Label>
              <Input
                type="text"
                name="reference"
                id="reference"
                onChange={(event) => {
                  register("reference");
                  setValue("reference", event.target.value);
                }}
                className={classNames({
                  "border-danger": errors.reference?.message,
                })}
                innerRef={register({
                  required: "Referencia requerida.",
                  pattern: {
                    value: /^[a-zA-Z0-9 %]+$/i,
                    message: "Solo se aceptan alfanúmericos.",
                  },
                })}
              />
              <WizardError
                error={errors.reference?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </Col>
          </Row>

          <Row form>
            <Col sm tag={FormGroup}>
              <Label for="payment_date">
                Fecha del pago <span className="text-danger">*</span>
              </Label>
              <Controller
                name="payment_date"
                control={control}
                rules={{ required: "La fecha del pago es obligatoria." }}
                render={({ onChange, value: dateValue }) => (
                  <Datetime
                    value={dateValue ? moment(dateValue) : ""}
                    className={`w-100 ${errors.payment_date?.message ? "border-danger" : ""
                      }`}
                    onChange={(date) => {
                      const parsedDate = moment(date);
                      onChange(
                        parsedDate.isValid() ? parsedDate.format("YYYY-MM-DD") : ""
                      );
                    }}
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                  />
                )}
              />
              <WizardError
                error={errors.payment_date?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </Col>
            <Col sm tag={FormGroup}>
              <Label for="acronym">Origen de fondos</Label>
              <Controller
                name="pay_from_account_current"
                control={control}
                rules={{
                  required: {
                    value: true,
                    message: "Seleccione un fondo",
                  },
                }}
                render={({ onChange, name, value }) => (
                  <Input
                    type="select"
                    name="pay_from_account_current"
                    id="pay_from_account_current"
                    value={selectedFundSource}
                    onChange={(event) => {
                      const val = event.target.value;
                      setSelectedFundSource(val);
                      setShouldSyncAmountWithSource(true);

                      if (val && val !== "Selecciona") {
                        clearErrors("pay_from_account_current");
                      }

                      if (val.startsWith("BANK_")) {
                        const bankId = val.split("_")[1];
                        setFund(true);
                        setValue("pay_from_account_current", val);
                        setValue("bank_id", bankId);
                        onChange(val);
                      } else if (val === "CURRENT") {
                        setFund(true);
                        setValue("pay_from_account_current", val);
                        setValue("bank_id", null);
                        onChange(val);
                      } else {
                        setFund(false);
                        setValue("pay_from_account_current", "Selecciona");
                        setValue("bank_id", null);
                        setValue("reserve_fund_id", null);
                        onChange("Selecciona");
                      }
                    }}
                    /*    onChange={handleInputChange}
                   innerRef={register({
                     required: { value: true, message: "Ingresar el monto" },
                   })} */
                    className={classNames({
                      "border-danger": errors.pay_from_account_current?.message,
                    })}
                  >
                    <option value="Selecciona">
                      ---
                    </option>
                    {renderFundsItems2()}
                  </Input>
                )}
              />
              <WizardError
                error={errors.pay_from_account_current?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </Col>
            {/*     {renderFundsItems()} */}
          </Row>

          <Row form>
            <Col tag={FormGroup}>
              <Label className="d-block">Fondo de reserva</Label>
              <div className="btn-group btn-group-sm d-flex" role="group" aria-label="Fondo de reserva">
                <button
                  type="button"
                  className={classNames("btn flex-fill", {
                    "btn-primary": usesReserveFund,
                    "btn-outline-primary": !usesReserveFund,
                  })}
                  onClick={() => {
                    setUsesReserveFund(true);
                    clearErrors("reserve_fund_id");
                  }}
                >
                  <FontAwesomeIcon icon={faPiggyBank} className="mr-1" />
                  Sí aplica
                </button>
                <button
                  type="button"
                  className={classNames("btn flex-fill", {
                    "btn-primary": !usesReserveFund,
                    "btn-outline-primary": usesReserveFund,
                  })}
                  onClick={() => {
                    setUsesReserveFund(false);
                    setValue("reserve_fund_id", null);
                    clearErrors("reserve_fund_id");
                  }}
                >
                  <FontAwesomeIcon icon={faBan} className="mr-1" />
                  No aplica
                </button>
              </div>
            </Col>
          </Row>

          {usesReserveFund && (
            <Row form>
              <Col sm tag={FormGroup}>
                <Label for="reserve_fund_id" className="mt-1">
                  Seleccione un fondo de reserva
                </Label>
                <Input
                  name="reserve_fund_id"
                  id="reserve_fund_id"
                  type="select"
                  className={classNames("position-relative m-0", {
                    "border-danger": errors.reserve_fund_id?.message,
                  })}
                  defaultValue="Selecciona"
                  onChange={(event) => {
                    setValue("reserve_fund_id", event.target.value);
                    if (event.target.value !== "Selecciona") {
                      clearErrors("reserve_fund_id");
                    }
                  }}
                >
                  <option value="Selecciona">---</option>
                  {renderReserveItems()}
                </Input>
                <WizardError
                  error={errors.reserve_fund_id?.message}
                  className="fs--1 font-weight-normal d-block"
                />
              </Col>
            </Row>
          )}

          <Row form>
            <Col sm tag={FormGroup}>
              <Label for="monedaOriginal">Moneda a pagar</Label>
              <Input
                type="select"
                name="monedaOriginal"
                id="monedaOriginal"
                aria-label="Moneda a pagar"
                value={watchedCurrency || ""}
                onChange={(event) =>
                  setValue("monedaOriginal", event.target.value, {
                    shouldDirty: true,
                  })
                }
              >
                {(currencyCatalog || []).map((item) => (
                  <option key={String(item.id)} value={String(item.id)}>
                    {`${item.iso} (${item.name})`}
                  </option>
                ))}
              </Input>
            </Col>
            <Col sm tag={FormGroup}>
              <Label for="amount">Monto</Label>
              <Controller
                name="amount"
                control={control}
                rules={{
                  maxLength: {
                    value: debttopay.amount - debttopay.total_paid,
                    message: "El monto no debe ser mayor a .",
                  },
                }}
                render={({ onChange, name, value }) => (
                  <NumberFormat
                    fixedDecimalScale={true}
                    prefix={amountPrefix}
                    decimalScale={2}
                    className={`form-control`}
                    placeholder="Monto"
                    {...register("amount")}
                    value={amount}
                    onValueChange={(values) => {
                      const nextAmount = Number(values.value);
                      if (Math.abs(nextAmount - Number(lastAutoAmountRef.current)) >= 0.01) {
                        hasManualAmountOverrideRef.current = true;
                      }
                      setAmount(nextAmount);
                      setValue("amount", nextAmount);
                    }}
                    isAllowed={({ floatValue }) => {
                      if (floatValue === undefined) {
                        return true;
                      }

                      return floatValue <= maxAllowedAmount;
                    }}
                    thousandSeparator={true}
                    disabled={!fund}
                    renderText={(value, props) => <div {...props}>{value}</div>}
                  />
                )}
              />
              <WizardError
                error={errors.amount?.message}
                className="fs--1 font-weight-normal d-block"
              />
              {isRateLoading && !isSelectedCurrencyBase && (
                <div className="text-700 fs--1 mt-1">
                  Consultando tasa para la fecha...
                </div>
              )}
              {conversionHelpText ? (
                <div className="text-700 fs--1 mt-1">{conversionHelpText}</div>
              ) : null}
            </Col>
          </Row>

          {!isSelectedCurrencyBase && rateResolution?.isFallback && !isRateLoading && (
            <Alert color="warning" className="py-2 fs--1">
              No se encontró la tasa registrada para el{" "}
              <strong>
                {moment(rateResolution.selectedDateKey).format("DD/MM/YYYY")}
              </strong>
              . Registra la tasa de ese día antes de emitir el pago.
            </Alert>
          )}

          <Row form>
            <Col sm tag={FormGroup}>
              <Label for="description">Descripción</Label>
              <Input
                /*                 disabled={debttopay ? true : false} */
                type="text"
                name="description"
                rows={6}
                placeholder="Ingrese un detalle de la cuenta a pagar"
                onChange={(event) => {
                  register("description");
                  setValue("description", event.target.value);
                }}
                className={classNames({
                  "border-danger": errors.description?.message,
                })}
                innerRef={register({
                  required: "La descripcion es requerida.",
                  pattern: {
                    value: /^[a-zA-Z0-9 %]+$/i,
                    message: "Solo se aceptan alfanúmericos.",
                  },
                })}
              />
              <WizardError
                error={errors.description?.message}
                className="fs--1 font-weight-normal d-block"
              />
            </Col>
          </Row>

          <Row>
            <Col tag={FormGroup}>
              <FileUploadArea
                label="Comprobante de pago"
                accept="image/*,application/pdf"
                onChange={(e) => {
                  const f = e.target.files[0];
                  if (f) {
                    setFile(f);
                    setImagePreview(URL.createObjectURL(f));
                  }
                }}
                preview={imagePreview}
                fileName={file?.name}
                onRemove={() => {
                  setFile(null);
                  setImagePreview(null);
                }}
              />
            </Col>
          </Row>
        </CardBody>

        <CardFooter className={classNames("px-md-6 bg-light d-flex")}>
          <ButtonIcon
            color="falcon-default"
            className="ml-auto px-5 mr-2"
            icon={faUndo}
            onClick={() => {
              setRedirectUrl(`/dashboard/${moduleBase}/${id}/topay`);
              setRedirect(true);
            }}
            iconAlign="right"
            transform="down-1 shrink-4"
          >
            Volver
          </ButtonIcon>
          <ButtonIcon
            color="primary"
            className="px-5"
            /*     onClick={() => collapseOneOpen(!collapseOne)} */
            icon="save"
            /*   disabled={Object.keys(errors).length > 0} */
            /*         onClick={handleSubmit(handleSubmitData)} */
            iconAlign="right"
            transform="down-1 shrink-4"
          >
            Guardar
          </ButtonIcon>
        </CardFooter>

        <Modal isOpen={collapseOne} data-testid="modal">
          <ModalHeader>Confirmación</ModalHeader>
          <ModalBody>
            <p className="mb-0 font-weight-bold fs--1">
              ¿Está seguro de que ingresó todos los datos correctamente? Esta
              información no puede ser cambiada posteriormente.
            </p>
          </ModalBody>
          <ModalFooter>
            <Button onClick={() => collapseOneOpen(!collapseOne)}>
              Cancelar
            </Button>
            <Button
              data-testid="submit-button"
              color="primary"
              type="submit"
              /*    disabled={Object.keys(errors).length > 0} */
              onClick={handleSubmit(createS)}
            >
              Sí, registrar
            </Button>
          </ModalFooter>
        </Modal>
      </>
    );
  };
  <br />;
  // eslint-disable-next-line no-lone-blocks
  {
    debttopay && (
      <Card>
        <FalconCardHeader
          title="Facturas adicionales"
          // eslint-disable-next-line react/no-children-prop
          children={
            <ButtonIcon
              color="falcon-default"
              icon={faPlus}
              onClick={() => setIsAdd(!isAdd)}
            >
              {!isAdd ? "Agregar" : "Ocultar"}
            </ButtonIcon>
          }
        />
      </Card>
    );
  }

  return (
    <>
      <Card
        className="bg-light mb-0"
        data-testid="form"
        tag={Form}
        onSubmit={handleSubmit(createS)}
      >
        <PreloadState loading={isSubmitting} message="Guardando pago...">
          {renderForm()}
        </PreloadState>
      </Card>
    </>
  );
};

export default withRedirect(CreateDebtToPayForm);
